// Every top-level column on the `orders` table that can be requested by
// `exportOrdersCsv`. Shared between the backend usecase (single source of
// truth via a `satisfies` check against the Drizzle schema) and the CRM
// frontend (multi-select).
export const ORDER_CSV_FIELDS = [
  'id',
  'storeId',
  'accountId',
  'createdAt',
  'updatedAt',
  'status',
  'cancelledAt',
  'cancelledReason',
  'paidAt',
  'paidAmount',
  'openAt',
  'abandonedAt',
  'currency',
  'externalCustomerType',
  'externalCustomerId',
  'externalOrderId',
  'billingAddress',
  'shippingAddress',
  'pickupAddress',
  'taxesIncluded',
  'draft',
  'checkoutSessionId',
  'sessionHash',
  'customerId',
  'createdFrom',
  'paymentInstrumentId',
  'refundedAt',
  'refundedAmount',
  'metadata',
  'noteAttributes',
  'orderNumber',
] as const;

export type OrderCsvField = (typeof ORDER_CSV_FIELDS)[number];

// Sensible defaults for the CRM "export" multi-select.
export const ORDER_CSV_FIELDS_ESSENTIALS: readonly OrderCsvField[] = [
  'id',
  'orderNumber',
  'status',
  'paidAmount',
  'currency',
  'createdAt',
  'customerId',
];
